import React from 'react'

const About = () => {
  return (
    <section id="about" class="about section">
      <div class="container section-title" data-aos="fade-up">
        <h2>About Us</h2>
      </div>
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-6 content" data-aos="fade-up" data-aos-delay="100">
            <p>
              <strong>TechBiz <span class="sitename-2">SoftwareSolutions</span></strong> is a leading IT company specializing in website development, mobile applications, and custom web solutions. 
              We empower businesses with cutting-edge technology, ensuring seamless digital transformation and superior user experiences.
            </p>
            <ul>
              <li><i class="bi bi-check2-circle"></i> <span>Scalable and responsive websites designed for maximum impact.</span></li>
              <li><i class="bi bi-check2-circle"></i> <span>Feature-rich mobile applications for iOS and Android platforms.</span></li>
              <li><i class="bi bi-check2-circle"></i> <span>Intelligent web applications that drive efficiency and innovation.</span></li>
              <li><i class="bi bi-check2-circle"></i> <span>Enterprise-grade software solutions to streamline operations.</span></li>
            </ul>
          </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <p>
              With a team of highly skilled developers and designers, we craft robust, secure, and scalable software solutions tailored 
              to your business needs. Whether you're a startup or an enterprise, we help you stay ahead with next-gen technology 
              and seamless digital experiences.
            </p>
            <a href="#services" class="read-more"><span>Explore Our Solutions</span><i class="bi bi-arrow-right"></i></a>
          </div>
        </div>
      </div>

    </section>
  )
}

export default About
